'use strict';
define([
    'angular',
    'modules/keywordlistmanager/shared/shared.controller'
], function (angular, KeywordListManagerSharedCtrl) {
    var app = angular.module('app.keywordlistmanager.shared', []);
    app.controller('KeywordListManagerSharedCtrl', KeywordListManagerSharedCtrl);
    return app;
});
